import { LucideIcon } from "lucide-react";

interface AdminStatsCardProps {
  icon: LucideIcon;
  label: string;
  value: number | string;
  iconColor?: string;
}

export const AdminStatsCard = ({ icon: Icon, label, value, iconColor = "text-primary" }: AdminStatsCardProps) => {
  return (
    <div className="p-6 rounded-xl bg-[#222222] border border-white/10 backdrop-blur-sm hover:bg-[#2A2A2A] transition-colors">
      <div className="flex items-center gap-4">
        <Icon className={`h-8 w-8 ${iconColor}`} />
        <div>
          <p className="text-sm font-medium text-gray-400">{label}</p>
          <p className="text-2xl font-bold text-white">{value}</p>
        </div>
      </div>
    </div>
  );
};